import React from "react";
import { Box } from "@mui/material";

export default function AppStatGrid({
  children,
  columns = 4,
  gap = 14,
  sx,
  ...props
}) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        gap: `${gap}px`,
        mb: "18px",
        "@media (max-width: 1100px)": {
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        "@media (max-width: 760px)": {
          gridTemplateColumns: "1fr",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
